<template>
    <aside v-if="open" class="side-panel" :aria-label="title" tabindex="-1" ref="panel" @keydown.esc="$emit('close')">
        <div class="sp-head">
            <div class="sp-head-text">
                <div v-if="kicker" class="sp-kicker">{{ kicker }}</div>
                <h2>{{ title }}</h2>
                <div v-if="subtitle" class="sp-sub">{{ subtitle }}</div>
            </div>
            <button type="button" class="sp-close" aria-label="Close" @click="$emit('close')"><i class="el-icon-close"></i></button>
        </div>
        <slot/>
    </aside>
</template>

<script>
// Right-hand detail panel shared by the list pages. The page keeps its list usable
// beside it on wide screens (add class "has-panel" to the page) and it covers the
// list on narrow ones.
export default {
    name: "SidePanel",
    props: {
        open: {type: Boolean, default: false},
        kicker: {type: String, default: ''},
        title: {type: String, default: ''},
        subtitle: {type: String, default: ''},
        // Changes when another record is shown, to move focus into the panel.
        recordKey: {type: [String, Number], default: null},
    },
    watch: {
        recordKey: {
            immediate: true,
            handler() {
                this.$nextTick(() => this.$refs.panel && this.$refs.panel.focus());
            },
        },
    },
}
</script>

<style>
.side-panel {
    position: fixed;
    top: 56px;
    right: 0;
    bottom: 0;
    width: 440px;
    max-width: 100vw;
    /* Above the sidebar and its arrow: on a phone the panel covers the full width. */
    z-index: 120;
    background: #FFFFFF;
    border-left: 1px solid #E3E6EE;
    box-shadow: -8px 0 24px rgba(20, 32, 63, .08);
    overflow-y: auto;
    padding: 22px 22px 40px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    outline: none;
}

.side-panel .sp-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
}

.side-panel .sp-head-text {
    min-width: 0;
}

.side-panel h2 {
    margin: 4px 0 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.35;
    overflow-wrap: anywhere;
}

.side-panel .sp-kicker {
    color: #5B6478;
    font-size: 12px;
}

.side-panel .sp-sub {
    color: #5B6478;
    font-size: 13px;
    margin-top: 4px;
}

.side-panel .sp-close {
    width: 32px;
    height: 32px;
    flex: none;
    border: 0;
    border-radius: 8px;
    background: #F1F3F7;
    cursor: pointer;
    font-size: 16px;
}

.side-panel h3 {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
}

/* Two-column fact tiles. */
.side-panel .sp-facts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.side-panel .sp-facts > div {
    padding: 10px 12px;
    border-radius: 10px;
    background: #F7F8FB;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    overflow-wrap: anywhere;
}

.side-panel .sp-facts span {
    color: #5B6478;
    font-size: 12px;
}

.side-panel .sp-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.side-panel .sp-actions .el-button + .el-button {
    margin-left: 0;
}

@media (min-width: 1280px) {
    .has-panel {
        margin-right: 440px;
    }
}

@media (max-width: 760px) {
    .side-panel {
        width: 100vw;
        padding: 16px 16px 32px;
    }
}
</style>
